import { render } from "./UserApproveModal.vue?vue&type=template&id=d2f0e1e2&ts=true"
import script from "./UserApproveModal.vue?vue&type=script&lang=ts"
export * from "./UserApproveModal.vue?vue&type=script&lang=ts"

import "./UserApproveModal.vue?vue&type=style&index=0&id=d2f0e1e2&lang=scss"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__